import React, { useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
import { IMAGES } from './data/landing';
import { loadMetaPixel } from './utils/metaPixel';
const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;700;800&family=Cinzel:wght@600&display=swap';
function addLink(attrs: Record<string, string>): HTMLLinkElement {
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([key, value]) => {
    link.setAttribute(key, value);
  });
  document.head.appendChild(link);
  return link;
}
export function App() {
  // Critical path: warm up the CDN and fetch the LCP image as early as possible.
  useEffect(() => {
    addLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    addLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    addLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    addLink({
      rel: 'preload',
      as: 'image',
      href: IMAGES.heroMockup,
      fetchpriority: 'high'
    });

    // Fonts load without blocking the first render, then swap in.
    const fonts = addLink({
      rel: 'stylesheet',
      href: FONTS_HREF,
      media: 'print'
    });
    const activate = () => {
      fonts.media = 'all';
    };
    fonts.addEventListener('load', activate);
    return () => fonts.removeEventListener('load', activate);
  }, []);

  // Meta Pixel is deferred so it never competes with the initial render.
  useEffect(() => {
    let cancelled = false;
    const loadPixel = () => {
      if (cancelled) return;
      loadMetaPixel();
    };

    // Schedule it in idle time so it never lands inside a long main-thread task.
    const schedule = () => {
      const idle = (window as any).requestIdleCallback;
      if (typeof idle === 'function') {
        idle(loadPixel, {
          timeout: 2000
        });
      } else {
        loadPixel();
      }
    };
    const timer = window.setTimeout(schedule, 4000);
    const onInteraction = () => {
      window.clearTimeout(timer);
      schedule();
    };
    window.addEventListener('pointerdown', onInteraction, {
      once: true
    });
    window.addEventListener('scroll', onInteraction, {
      once: true,
      passive: true
    });
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      window.removeEventListener('pointerdown', onInteraction);
      window.removeEventListener('scroll', onInteraction);
    };
  }, []);
  return <LandingPage data-id="element-0" data-mp="3glnxu0wbr0i8" />;
}